import { createContext, useContext, useState, useEffect } from 'react';
import api from '@/lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initAuth = async () => {
      const token = localStorage.getItem('pilot_token');
      if (token) {
        try {
          // Always fetch fresh user data from server
          const res = await api.get('/auth/me');
          localStorage.setItem('pilot_user', JSON.stringify(res.data));
          setUser(res.data);
        } catch (err) {
          // Token invalid, clear everything
          localStorage.removeItem('pilot_token');
          localStorage.removeItem('pilot_user');
        }
      }
      setLoading(false);
    };
    initAuth();
  }, []);

  const login = async (email, password) => {
    const res = await api.post('/auth/login', { email, password });
    localStorage.setItem('pilot_token', res.data.token);
    localStorage.setItem('pilot_user', JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data;
  };

  const register = async (email, password, name) => {
    const res = await api.post('/auth/register', { email, password, name });
    localStorage.setItem('pilot_token', res.data.token);
    localStorage.setItem('pilot_user', JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem('pilot_token');
    localStorage.removeItem('pilot_user');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
